
import Vue, { VNode } from 'vue'
export default Vue.extend({
    functional: true,
    props: {
        value: Object as () => VNode,
    },
    render: (h, ctx) => ctx.props.value,
});
